import { getURLParams } from 'js/utils/url.util';
import { IGame, TGamesGridLayoutSize, LAYOUT_SIZES } from 'js/hooks/games/types';

import * as Types from './types';

export const getGamesGridActiveTab = (gamesGridTabs: Types.IGamesGridTab[] = []): Types.IGamesGridTab | undefined => {
    const { gamesGridTab } = getURLParams(location.search);
    const currentTabByGETParameter = gamesGridTabs.find((tab) => tab.tabName === gamesGridTab);

    if (currentTabByGETParameter?.tabGameFeed && !currentTabByGETParameter.pageURL) {
        return currentTabByGETParameter;
    }

    if (gamesGridTabs[0]?.tabGameFeed && !gamesGridTabs[0]?.pageURL) {
        return gamesGridTabs[0];
    }
};

export const getGamesFeedNameAndTab = (
    gamesGridTabs: Types.IGamesGridTab[] = [],
    defaultGameFeed?: string
): { gamesGridFeedName: string; gamesGridActiveTab: Types.IGamesGridTab | undefined } => {
    const gamesGridActiveTab = getGamesGridActiveTab(gamesGridTabs);
    const gamesGridFeedName = gamesGridActiveTab?.tabGameFeed || defaultGameFeed || '';

    return {
        gamesGridFeedName,
        gamesGridActiveTab
    };
};

export const isGameAvailable = ({ gameCode, allGames, isInternalPlayer }: {
    gameCode: string;
    isInternalPlayer?: string;
    allGames: { [key: string]: IGame };
}): boolean => {
    const game = allGames[gameCode];

    return (
        Boolean(game) &&
        (game.gameMode !== 'maintenance' || game.gameMode === 'maintenance' && isInternalPlayer === '1')
    );
};

export const filterGamesByAvailability = ({ gameCodes = [], allGames, isInternalPlayer }: {
    gameCodes: string[];
    isInternalPlayer?: string;
    allGames: { [key: string]: IGame };
}): string[] => {
    return gameCodes.filter((gameCode) => isGameAvailable({ gameCode, allGames, isInternalPlayer }));
};

export const gameTileRatio = (size?: TGamesGridLayoutSize): number => {
    switch (size) {
        case LAYOUT_SIZES.landscape:
            return 1 / 1.597;
        case LAYOUT_SIZES.portrait:
            return 1.494;
        default:
            return 1;
    }
};

